import PropTypes from "prop-types";

import styles from "./styles/form.module.css";

import { EmailInput } from "./EmailInput";

export function Form({
  values,
  emailKey,
  handleChange,
  handleSubmit,
  errors,
  isSubmitting,
  buttonLabel,
}) {
  const loading = Object.keys(errors).length === 0 && isSubmitting;
  let buttonTxt = buttonLabel;
  if (loading) {
    buttonTxt = "Joining Waitlist";
  }
  return (
    <div className={styles.container}>
      <EmailInput values={values} emailKey={emailKey} handleChange={handleChange} />
      <button className={styles.submit} type="button" onClick={handleSubmit} disabled={loading}>
        {buttonTxt}
      </button>
    </div>
  );
}

Form.propTypes = {
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])).isRequired,
  emailKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  buttonLabel: PropTypes.string.isRequired,
};
